import React from 'react';

import { Chip, Stack, Typography } from '@mui/material';

import { AnyRecommendationPending } from './TccPricingProvider';
import { money } from './logic';
import { rmStatus } from './reviewLogic';
import type { CommandDeparture } from './types';

export default function RMStatusChips({
  rows,
  lossExposure,
}: {
  rows: Array<CommandDeparture>;
  lossExposure?: number | null;
}) {
  const statuses = [...new Set(rows.map(rmStatus))];
  return (
    <Stack direction="row" gap={0.5} flexWrap="wrap" alignItems="center" sx={{ mt: 0.5 }}>
      {statuses.map((status) => (
        <Chip
          key={status}
          size="small"
          variant="outlined"
          label={`${status}${statuses.length > 1 ? ` ${rows.filter((d) => rmStatus(d) === status).length}` : ''}`}
          sx={{ height: 'auto', minHeight: 18, fontSize: 10, '& .MuiChip-label': { px: 0.5, whiteSpace: 'normal' } }}
        />
      ))}
      {lossExposure > 0 && <Typography variant="caption">{money(lossExposure)} at risk</Typography>}
      <AnyRecommendationPending rows={rows} />
    </Stack>
  );
}
